import React, { useState, useEffect, Fragment } from 'react'
import { MyStore } from '../../../../services/Store'
import { Route, NavLink, Switch, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import {Consumer } from '../../../../context/Context'

import SidePanel from '../groups/SidePanel'
import {   Dropdown, Sidebar, Menu, Icon, Grid, Image, Segment, Header, Button, Form, Table, Modal, Checkbox } from 'semantic-ui-react'
import MasterForm from '../cards/MasterForm'

import CardList from '../cards/CardList'

import ProjectList from '../organization/ProjectList'


import CadreList from '../cards/CadreList'
import moment from 'moment'


import DashboardMembers from './DashboardMembers'
import ChatView from './ChatView'

import OrgHomePage from './OrgHomePage'

import CardView from './CardView'


const Dashboard = (props) => {
    // props.auth = MyStore.auth().currentUser
    const currentUser = MyStore.auth().currentUser
    const [state, setState] = useState({
        animation: 'push',
        direction: 'left',
        dimmed: false,
        visible: true,

        showModal: false,
        showRoomModal: false,
        showQrModal: false,
        // service: '',
        // key:0,
        // imail: '',
        // roomUrl :'https://metachat.app.com/t/',
    })

    // const [addCurrentUser, setAddCurrentUser] = useState({
    //     role: '',
    //     avatar: '',
    //     uid: '',
    //     displayName: '',
    //     avatar: '',
    //     username: '',
    //     key: '',

    // })

    const [currentGroup, setCurrentGroup] = useState({})
    // const [service, setService] = useState('Cadre Homepage')
    const [service, setService] = useState({value:'Cadre Homepage',key:0})
    const [oid, setOid] = useState()

    const [stateKey, setStateKey] = useState(0)

    const [currentKey, setCurrentKey] = useState(0)




    // let displayName = ''
    // let avatar = ''
    // const user = MyStore.auth().currentUser

    // const databaseRef = MyStore.database().ref();




    useEffect(() => {
        let id = props.match.params.id;
        id = props.match.params.id;

        setOid(id)
        // console.log(id)
        // console.log(props)
        // console.log(serviceOptions.keys())
        // console.log()
        // console.log(Object.keys(serviceOptions).length);

        // console.log('---------- currentKey ------------------ ')
        // console.log(currentKey)
        // console.log('----------  serviceOptions[currentKey].text ------------------ ')
        // console.log(serviceOptions[0].text)

        MyStore.auth().onAuthStateChanged((user) => {
            if (user) {

                MyStore.database().ref().child(`/groups/${id}`).on('value', snap => {
                    // let groups = []
                    // console.log(snap.val())
                    // cg = snap.val()
                    setCurrentGroup((snap.val()))
                })
            }
        })



    }, [])



   

    const displayHomePage = () =>{
        return(
            <OrgHomePage>

            </OrgHomePage>
        )
    }

    const displayDashboardMembers = () => {

        // console.log('--displayDashboardMembers--- line 399')
        if (typeof (oid) == 'string') {
            // console.log("typeof (oid) == 'string'")
            return (
                <DashboardMembers
                    oid={oid}
                    props={props}
                ></DashboardMembers>
            )


        }
    }


    

    const createNewProject = () => {

        // console.log('--displayDashboardMembers--- line 399')
        if (typeof (oid) == 'string') {
            // console.log("createNewProject")
            return (
  
                <Consumer>
                {value => {
                  const { auth, myFiles } = value;
        
                //   console.log(auth)
                  return (
           
 
                              <React.Fragment>
                                <div  >
                                  <br></br><br></br>
                                  <MasterForm auth = {auth}     oid={oid}
                                    props={props}
                                    >
        
                                  </MasterForm>
        
        
        
                                </div>
                              </React.Fragment>
      
        
                  );
                }}
              </Consumer>
            )


        }
    }


    // problem with route refresh 
    // const createNewProject = ()=>(


    //     <Switch>
    //     <Route  to="/cadre/:id/dashboard/create"  component={MasterForm} />
    //     {/* <Redirect from="/dashboard:id" to="/dashboard/:id" /> */}
    //   </Switch>
    // )



    const patientProjects2 = () => {

        // console.log('--patientProjects--- line 153')
        if (typeof (oid) == 'string') {
            // console.log("typeof (oid) == 'string'")
            // return (
            //     <DashboardMembers
            //         oid={oid}
            //         props={props}
            //     ></DashboardMembers>
            // )
            return(
            <ProjectList 
                    oid={oid}
                props={props}
            ></ProjectList>)


        }
    }



    const patientProjects = () => {

        // console.log('--patientProjects--- line 153')
        if (typeof (oid) == 'string') {
            // console.log("typeof (oid) == 'string'")
            // return (
            //     <DashboardMembers
            //         oid={oid}
            //         props={props}
            //     ></DashboardMembers>
            // )
            return(
            <CardView 
                    oid={oid}
                props={props}
            ></CardView>)


        }
    }



    const displayChatView = () => {
        // console.log('--displayChatView--- line 154')
        if (typeof (oid) == 'string') {
            // console.log("typeof (oid) == 'string'")
            // return (
            //     <DashboardMembers
            //         oid={oid}
            //         props={props}
            //     ></DashboardMembers>
            // )
            return(
            <ChatView 
                    oid={oid}
                props={props}
            ></ChatView>)
        }
    }


    const handleLeftSidebar = (boolVal) => () =>
    setState({ visible: boolVal })



 

    const vertical = state.direction === 'bottom' || state.direction === 'top'


    const handleDirectionChangeTrue = (direction) => () =>
        setState({ direction, visible: true })


        
    const handleAnimationChange = (animation) => () =>
        setState((prevState) => ({ animation, visible: !prevState.visible }), handleDirectionChangeTrue('left'))




    // {'' || currentGroup.oname}


    // const ButtonMultipleConditionals = () => (
    //         <Button   inverted color='black' size ='massive'
    //          style={{ padding: '0px', float: 'center', margin:'0px',  marginTop: '1vh',
    //          height:'10vh',
    //           border: "3px solid transparent", boxShadow: "none", 

    //         }}
    //         onClick={handleAnimationChange('slide out')}> {'' || currentGroup.oname}</Button>

    // )

    const ButtonMultipleConditionals = () => {
        
        const showSidebar = !state.visible
        return(
        <Button basic size='big' circular icon='sidebar'
            style={{
                padding: '0px', float: 'left', margin: '0px', marginTop: '1vh', width: "10vh", marginBottom: '1vh',
                height: '3.5vh', color: 'white', background: 'gray', border: "5px solid transparent", boxShadow: "none",

            }}
            // onClick={handleAnimationChange('slide out')}
            onClick={handleLeftSidebar(showSidebar)}
            
            >
            {/* <Icon name='sidebar' /> */}
        </Button>

    )
}

    const handleMenuChange = (value, key) => {
        //  alert(value)
        // console.log('----------- handleMenuChange -----------')
        // console.log(value)
        // console.log(key)
        setState({
            service: value,
            key: key
        })

        setService({value: value, key: key})
        setStateKey(key)
        setCurrentKey(key)
        

    }



    const buttonSelection = (onChange, value, key) => (
        <Button
      
            // fluid
            // selection
            // defaultValue={serviceOptions[0].text}
            // options={serviceOptions}
     
            value={serviceOptions[1].text}
            onClick={(e, { value, key }) => handleMenuChange(value, key)} />)



    const dropdownSelection = (onChange, value, key) => (
        <Dropdown
            placeholder='Select a  Service'
            fluid
            selection
            key={serviceOptions[1].key}
            //   defaultValue={serviceOptions[0].text}
            options={serviceOptions}
            onChange={(e, { value, key }) => handleMenuChange(value, key)} />)





    const handleItemClick = (e, { name }) => this.setState({ activeItem: name })

    const SegmentPadded = () => (
        <div style={{ padding: '0px' }}>
            <Segment style={{
                background: "transparent",
                border: "0px solid transparent",
                boxShadow: "none",
                padding: "0em 0em",
                textAlign: 'center',
            }} >

                <Grid columns={1} >
                    <Grid.Column>
                        {ButtonMultipleConditionals()}
                        <Header  style={{ padding: '0px', textAlign:'justified'}} >
                            {/* <Icon name='user' /> */}
                            {/* <Image src={avatar} /> */}
                            {/* {currentGroup.oname} */}
                            <h1  style={{  marginRight:'7vw', textAlign: "center" }} >
                                {/* <Header.Subheader> <b>Organization</b></Header.Subheader> */}
                                {'' || currentGroup.oname}
                            </h1>
                        </Header>
                    </Grid.Column>
                </Grid>
            </Segment>
        </div>
    )



const dashboardControl = key =>{
    // console.log('------- dashboardControl --------- ')
    // console.log(key)
    switch(key) {
        case 0:

          // code block
          return displayHomePage()
          break;
        case 1:
          // code block
          return displayDashboardMembers()
          break;
       case 2:
        return createNewProject()
        break;
        case 3:
            return patientProjects()
            break;
        case 4:
            return displayChatView()
            break;
        default:
          // code block
      }
}   


const VerticalSidebar = ({ animation, direction, visible }) => (
    <Sidebar
        as={Menu}
        animation={animation}
        direction={direction}
        icon='labeled'
        // inverted
        vertical
        visible={visible}
        width='thin'
        style={{
            background: "transparent",
            border: "1px solid transparent",
            boxShadow: "none",
            padding: "0em 0em",
            height: "6vw",
        }}
    >

{/* 
        <NavLinkWithChildrenFunc exact to="/cardlist/card/add">
            {match => (
                <Menu.Item active={!!match}>
                    <Icon name="wpforms" />
                    Create a new Project
                  </Menu.Item>
            )}
        </NavLinkWithChildrenFunc> */}
{/* 
        value={serviceOptions[0].text}
            onClick={(e, { value }) => handleMenuChange(value)} />) */}

<Menu.Item style={{ cursor: "pointer" } }    onClick={(e, { value }) => handleMenuChange(value, 0)}   value={serviceOptions[0].text}>
             <Icon name="hospital outline" />
            Cadre Home
              </Menu.Item>

        <Menu.Item style={{ cursor: "pointer" } }    onClick={(e, { value }) => handleMenuChange(value, 1)}   value={serviceOptions[1].text}>
            <Icon name="users" />
           Cadre Members
              </Menu.Item>

        <Menu.Item style={{ cursor: "pointer" }} onClick={(e, { value }) => handleMenuChange(value, 2)}   value={serviceOptions[2].text}>
            <Icon name="wpforms" />
            Create a new Project
              </Menu.Item>

        <Menu.Item style={{ cursor: "pointer" }}  onClick={(e, { value }) => handleMenuChange(value, 4)}   value={serviceOptions[4].text}>
            <Icon name="chat" />
            Chat View
              </Menu.Item>


        <Menu.Item style={{ cursor: "pointer" }} onClick={(e, { value }) => handleMenuChange(value, 3)}   value={serviceOptions[3].text}>
            <Icon name="user outline" />
            Patient Projects
              </Menu.Item>


        {/* <NavLinkWithChildrenFunc exact to="/">
            {match => (
                <Menu.Item active={!!match}>
                    <Icon name="home" />
                    Home
                  </Menu.Item>
            )}
        </NavLinkWithChildrenFunc> */}


        {/* <Menu.Item style={{ cursor: "pointer" }}>
            <Icon name="folder outline" />
            Project View
              </Menu.Item> */}



    </Sidebar>
)


let count = 0

    return (
        <React.Fragment>
            {SegmentPadded()}
            <div  >
                <Sidebar.Pushable as={Segment}>
                    {vertical ? (
                        <HorizontalSidebar
                            animation={state.animation}
                            direction={state.direction}
                            visible={state.visible}
                        />
                    ) : null}
                    {vertical ? null : (
                        <VerticalSidebar
                            animation={state.animation}
                            direction={state.direction}
                            visible={state.visible}
                        />
                    )}

                    <Sidebar.Pusher dimmed={state.dimmed && state.visible} >
                    {service.value == '' ? null : (<h1>{service.value} </h1>)}  
                        {/* {displayDashboardMembers()} */}

                        <div style={{minHeight: '100vh',  }}>
                            
                            {/* {console.log(service.key)}
                            {console.log(currentKey)} */}

                        {service.key !== currentKey ?  null: (<> {dashboardControl(service.key)}</>) }


 

                       {/* {displayDashboardMembers()} */}
                             {/* {dashboardControl(currentKey)} */}

                        {/* {state.key === serviceOptions[0].key ? (
                        <React.Fragment>
                            
                            <Header> serviceOptions [zero] {state.key} {currentKey} {service}</Header>
                             <Header> {currentKey}</Header>
                         <h1>Newsletter</h1>
                            

                        </React.Fragment>
                      ) : (
                          <React.Fragment>
                            {service=== serviceOptions[currentKey].text ? (
                              <React.Fragment>
                             <Header> serviceOptions [{currentKey}] {state.key} {currentKey} {service}</Header>
                             <Header> {currentKey}</Header>
                         <h1>Newsletter</h1>
                               
             
      
                              </React.Fragment>
                            ) : (
                                <React.Fragment  >
                      
                      <Header> {state.key} </Header>

                                </React.Fragment>
                              )}
                          </React.Fragment>
                        )} */}



                        </div>
                        

{/* 
                        <Segment basic>
                            <Header as='h3'>Application Content</Header>
                            <Image src='https://react.semantic-ui.com/images/wireframe/paragraph.png' />
                        </Segment>


                        <Segment basic>
                            <Header as='h3'>Application Content</Header>
                            <Image src='https://react.semantic-ui.com/images/wireframe/paragraph.png' />
                        </Segment>


                        <Segment basic>
                            <Header as='h3'>Application Content</Header>
                            <Image src='https://react.semantic-ui.com/images/wireframe/paragraph.png' />
                        </Segment>


                        <Segment basic>
                            <Header as='h3'>Application Content</Header>
                            <Image src='https://react.semantic-ui.com/images/wireframe/paragraph.png' />
                        </Segment> */}

                    </Sidebar.Pusher>
                </Sidebar.Pushable>
            </div>

        </React.Fragment>

    )


}






// VerticalSidebar.propTypes = {
//     animation: PropTypes.string,
//     direction: PropTypes.string,
//     visible: PropTypes.bool,
// }

const HorizontalSidebar = ({ animation, direction, visible }) => (
    <Sidebar
        as={Segment}
        animation={animation}
        direction={direction}
        visible={visible}
    //   width='thin'


    >
        <Grid textAlign='center'>
            <Grid.Row columns={1}>
                <Grid.Column>
                    <Header as='h3'>New Content Awaits</Header>
                </Grid.Column>
            </Grid.Row>
            <Grid columns={3} divided>
                <Grid.Column>
                    <Image src='https://react.semantic-ui.com/images/wireframe/media-paragraph.png' />
                </Grid.Column>
                <Grid.Column>
                    <Image src='https://react.semantic-ui.com/images/wireframe/media-paragraph.png' />
                </Grid.Column>
                <Grid.Column>
                    <Image src='https://react.semantic-ui.com/images/wireframe/media-paragraph.png' />
                </Grid.Column>
            </Grid>
        </Grid>
    </Sidebar>
)

HorizontalSidebar.propTypes = {
    animation: PropTypes.string,
    direction: PropTypes.string,
    visible: PropTypes.bool,
}

const NavLinkWithChildrenFunc = ({ to, exact = false, children, ...rest }) => (
    <Route path={to} exact={exact}>
        {({ match }) => (
            <NavLink to={to} {...rest}>
                {typeof children === "function" ? children(match) : children}
            </NavLink>
        )}
    </Route>
);


const serviceOptions = [
    // {
    //     key: '1',
    //     text: 'eResponse: Radiology chest xray pneumonia detection [ Seeking FDA Approval ]',
    //     value: 'eResponse: Radiology chest xray pneumonia detection [ Seeking FDA Approval ]',
    //     image: { avatar: true, src: '/images/avatar/small/elliot.jpg' },
    //     size: 'small',
    // },
    // {
    //     key: '2',
    //     text: 'Draft: Project Delivery',
    //     value: 'Draft: Project Delivery',
    //     image: { avatar: true, src: '/images/avatar/small/elliot.jpg' },
    //     size: 'small',
    // },
    // {
    //     key: '3',
    //     text: 'Select a Service',
    //     value: 'Draft: Project Delivery',
    //     image: { avatar: true, src: '/images/avatar/small/elliot.jpg' },
    //     size: 'small',
    // },
    {
        key:0,
        value:'default',
        text:' Cadre Homepage'
    },
    {
        key:1,
        value:'members',
        text:' Members in your Cadre'
    },
    {
        key:2,
        value:'create',
        text:' Create a new Project'
    },
    {
        key:3,
        value:'projectView',
        text:' Project View'
    },
    {
        key:4,
        value:'chatView',
        text:''
    },
    {
        key:5,
        value:'',
        text:' '
    },
    {
        key:6,
        value:' ',
        text:'  '
    }
]





// Dashboard.contextType = MyContext;
export default Dashboard